import React, { useState, useEffect } from 'react';
import { AlertTriangle, ArrowDownUp } from 'lucide-react';

function LowStock() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLowStock();
  }, []);

  const fetchLowStock = async () => {
    try {
      const res = await fetch('/inventory-app/api/products/low-stock');
      const data = await res.json();
      setProducts(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching low stock:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <AlertTriangle className="w-6 h-6 text-amber-500" />
          <h1 className="text-2xl font-bold text-slate-900">Low Stock Alerts</h1>
        </div>
        <p className="text-slate-500 mt-1">Products at or below minimum stock level</p>
      </div>

      {products.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-12 text-center">
          <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900">All Stock Levels Healthy</h3>
          <p className="text-slate-500 mt-1">No products are currently below their minimum stock level.</p>
        </div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-slate-100 bg-slate-50">
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">SKU</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Product</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Category</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Current Stock</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Min Level</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Shortfall</th>
                  <th className="text-left py-3 px-4 text-sm font-medium text-slate-500">Status</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => {
                  const shortfall = product.min_stock_level - product.quantity;
                  return (
                    <tr key={product.id} className="border-b border-slate-50 hover:bg-slate-50">
                      <td className="py-3 px-4 text-sm font-medium text-slate-900">{product.sku}</td>
                      <td className="py-3 px-4 text-sm text-slate-900">{product.name}</td>
                      <td className="py-3 px-4">
                        <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-slate-100 text-slate-700">
                          {product.category_name || 'Uncategorized'}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-sm font-bold text-red-600">{product.quantity}</td>
                      <td className="py-3 px-4 text-sm text-slate-500">{product.min_stock_level}</td>
                      <td className="py-3 px-4 text-sm font-medium text-red-600">{shortfall}</td>
                      <td className="py-3 px-4">
                        <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-700">
                          <ArrowDownUp className="w-3 h-3" />
                          Reorder
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default LowStock;
